var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Table = styled.table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  border-spacing: 0;\n  padding-bottom: 16px;\n  border: ", ";\n"], ["\n  ", "\n\n  border-spacing: 0;\n  padding-bottom: 16px;\n  border: ", ";\n"])), function (props) { return props.fullWidth && 'width: 100%;'; }, function (props) {
    return !props.noBorder ? "1px solid ".concat(props.theme.colors.border.base) : 'none';
});
var templateObject_1;
